import React from 'react';

const LegendPlaceholder = () => {
  return (
    <div className="legend-list legend-group">
      <div>
        <div className="text__placeholder--medium shimmer" />
        <div className="text__placeholder--medium shimmer placeholder__bottom-space" />
        <div className="text__placeholder--small shimmer placeholder__space" />
      </div>
    </div>
  );
};

export default LegendPlaceholder;
